/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Adjust_End_Time_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Adjust end time" |
*
* @param {Timeline_Adjust_End_Time_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_adjust_end_time_aria_label = /** @type {((inputs?: Timeline_Adjust_End_Time_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Adjust_End_Time_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajuster l'heure de fin")
	if (locale === "de") return /** @type {LocalizedString} */ ("Endzeit anpassen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Regola l'ora di fine")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Скорректировать время окончания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar la hora de finalización")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("调整结束时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("終了時間を調整する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समाप्ति समय समायोजित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ajustar horário de término")
	return /** @type {LocalizedString} */ ("Adjust end time")
});